/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Api_Keys_RevokeInputs */



/**
* | output |
* | --- |
* | "Revoke access instantly" |
*
* @param {Plan_Gate_Benefit_Api_Keys_RevokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_api_keys_revoke = /** @type {((inputs?: Plan_Gate_Benefit_Api_Keys_RevokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Api_Keys_RevokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriff sofort widerrufen")
	return /** @type {LocalizedString} */ ("Revoke access instantly")
});